module.exports = "https://portperrypedals.ca/_res/img/durham.28fa67a.png";